import { Provider } from '@angular/core';
import { PLATFORM_CONFIG } from './config.token';
import { PlatformConfig } from '../interfaces/config.interfaces';
import { deepMerge } from '../utils/deep-merge.util';
import { defaultConfig } from './default.config';

/**
 * Creates a provider for platform configuration
 * Merges default config with environment-specific overrides
 * 
 * @param environmentConfig - Environment-specific configuration overrides
 * @returns Provider for PLATFORM_CONFIG token
 */
export function providePlatformConfig(
  environmentConfig?: Partial<PlatformConfig>
): Provider {
  const mergedConfig = environmentConfig
    ? deepMerge({ ...defaultConfig }, environmentConfig)
    : defaultConfig;

  return {
    provide: PLATFORM_CONFIG,
    useValue: mergedConfig,
  };
}

